import React from 'react';
import { useTenantContext } from 'src/components/TenantProvider';
import getDeepLink from 'src/utils/getDeepLink';
import THINKIFIC_ICON_URL from './constants';

const TopBar = () => {
  const {
    queryParams: { shop },
    tenant: { subdomain },
  } = useTenantContext();

  return (
    <>
      <div className="top-bar" name="top-bar">
        <div className="top-bar__left-container">
          <img
            alt="logo"
            className="top-bar__left-container__icon"
            src={THINKIFIC_ICON_URL}
          />
          <h4 className="top-bar__left-container__text">
            Thinkific - Online Courses
          </h4>
        </div>

        <div className="top-bar__right-container">
          <a
            className="top-bar__right-container__button"
            href={`https://${shop}/admin`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Shopify
          </a>
          <a
            className="top-bar__right-container__button"
            href={getDeepLink(subdomain, 'manage')}
          >
            Thinkific Admin
          </a>
        </div>
      </div>
      <style jsx>{`
        .top-bar {
          display: flex;
          justify-content: space-between;
          height: 64px;
          background-color: #26254d;
          font-family: 'Barlow', sans-serif;
        }
        .top-bar__left-container,
        .top-bar__right-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fff;
        }
        .top-bar__left-container {
          margin-left: 24px;
        }
        .top-bar__left-container__icon {
          width: 24px;
          height: 24px;
        }
        .top-bar__left-container__text {
          display: none;
        }
        .top-bar__left-container__text:before {
          position: absolute;
          left: 0;
          content: '';
          height: 32px;
          width: 2px;
          background: #57608c;
          border-radius: 2px;
          transform: rotate(20deg);
        }
        .top-bar__right-container__button {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          position: relative;
          padding-left: 24px;
          padding-right: 16px;
          border: 1px solid transparent;
          outline: none;
          color: #caccd6;
          background-color: transparent;
          font-size: 14px;
          font-weight: 600;
          line-height: 18px;
          text-decoration: none;
          text-transform: uppercase;
          cursor: pointer;
        }
        .top-bar__right-container__button:hover,
        .top-bar__right-container__button:focus {
          background-color: rgba(255, 255, 255, 0.3);
        }
        .top-bar__right-container__button:before {
          position: absolute;
          width: 1px;
          height: calc(100% - 32px);
          left: 0;
          background-color: #57608c;
          content: '';
        }

        @media (min-width: 48.0625em) {
          .top-bar__left-container__text {
            display: flex;
            align-items: center;
            position: relative;
            margin-left: 24px;
            padding-left: 24px;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.3px;
            line-height: 24px;
          }
        }
      `}</style>
    </>
  );
};

export default TopBar;
